import { Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import CardDetailPage from './pages/CardDetailPage';
import NewMarketplacePage from './pages/NewMarketplacePage';
import CreateListingPage from './pages/CreateListingPage';
import EditListingPage from './pages/EditListingPage';
import ListingDetailPage from './pages/ListingDetailPage';
import TransactionDetailPage from './pages/TransactionDetailPage';
import BrowseCardsPage from './pages/BrowseCardsPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import BetaLoginPage from './pages/BetaLoginPage';
import AuthCallback from './pages/AuthCallback';
import HowToReportPage from './pages/HowToReportPage';
import HowToPage from './pages/HowToPage';
import HowToMarketplacePage from './pages/HowToMarketplacePage';
import ComingSoonPage from './pages/ComingSoonPage';
import AdminListingsPage from './pages/AdminListingsPage';
import ManageUsersPage from './pages/ManageUsersPage';
import AdminCardUploadPage from './pages/AdminCardUploadPage';
import AdminCSVImportPage from './pages/AdminCSVImportPage';
import AdminCardEditPage from './pages/AdminCardEditPage';

import PriceModerationPage from './pages/PriceModerationPage';
import PriceManagementPage from './pages/PriceManagementPage';
import AnnouncementManagementPage from './pages/AnnouncementManagementPage';
import CarouselManagementPage from './pages/CarouselManagementPage';
import LeaderboardPage from './pages/LeaderboardPage';
import CompetitionSchedulePage from './pages/CompetitionSchedulePage';
import AdminCompetitionSchedulePage from './pages/AdminCompetitionSchedulePage';
import SupportPage from './pages/SupportPage';
import AdminSupportPage from './pages/AdminSupportPage';
import AdminListingReportsPage from './pages/AdminListingReportsPage';

import NotificationsPage from './pages/NotificationsPage';
import AuctionListPage from './pages/AuctionListPage';
import AuctionDetailPage from './pages/AuctionDetailPage';
import AuctionBatchPage from './pages/AuctionBatchPage';
import CreateAuctionPage from './pages/CreateAuctionPage';
import UserReviewsPage from './pages/UserReviewsPage';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
// import ReportPriceListPage from './pages/ReportPriceListPage';
import { authService } from './services/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null); // Add user state
  const [loading, setLoading] = useState(true);
  const [showDiscordModal, setShowDiscordModal] = useState(false);

  useEffect(() => {
    // Check if user is authenticated on mount
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const authenticated = await authService.checkAuth();
          if (authenticated) {
            // If authenticated, get user profile to know role
            try {
              const userData = await authService.getProfile();
              setUser(userData);
              setIsAuthenticated(true);

              // Check Discord membership if logged in with Discord
              if (userData.discordId) {
                try {
                  const membership = await authService.checkDiscordMembership();
                  if (!membership.isMember) {
                    setShowDiscordModal(true);
                  }
                } catch (err) {
                  // Ignore errors, don't block login
                  console.error('Failed to check Discord membership', err);
                }
              }
            } catch (profileError) {
              console.error('Failed to fetch profile:', profileError);
              // Still authenticated but profile fetch failed - handle gracefully or retry?
              // For now, assume authenticated but maybe partial functionality
              setIsAuthenticated(true);
            }
          } else {
            setIsAuthenticated(false);
            setUser(null);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
          }
        } catch (error) {
          console.error('Auth check failed:', error);
          setIsAuthenticated(false);
          setUser(null);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
      setLoading(false);
    };

    checkAuth();

    window.addEventListener('auth-change', checkAuth);
    window.addEventListener('storage', checkAuth);

    return () => {
      window.removeEventListener('auth-change', checkAuth);
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }



  return (
    <div className="min-h-screen bg-gray-50">
      {showDiscordModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowDiscordModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-[#5865F2] mb-4">
                <svg className="h-8 w-8 text-white fill-current" viewBox="0 0 24 24">
                  <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.0824.0824 0 00.0312-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.419-2.1568 2.419zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.419-2.1568 2.419z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Join Our Discord Server</h3>
              <p className="text-sm text-gray-500 mb-6">
                To receive notifications and support messages, you need to be a member of our Discord server.
              </p>
              <div className="space-y-3">
                <a
                  href="https://discord.gg/sR5RUq9Z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#5865F2] hover:bg-[#4752C4] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5865F2]"
                  onClick={() => setShowDiscordModal(false)}
                >
                  Join Discord Server
                </a>
                <button
                  type="button"
                  className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={() => setShowDiscordModal(false)}
                >
                  I've Joined
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/how-to" element={<HowToPage />} />
        <Route path="/how-to-report" element={<HowToReportPage />} />
        <Route path="/how-to-marketplace" element={<HowToMarketplacePage />} />
        <Route path="/coming-soon" element={<ComingSoonPage />} />
        <Route path="/browse-cards" element={<BrowseCardsPage />} />
        <Route path="/marketplace" element={<NewMarketplacePage />} />
        <Route path="/marketplace/listing/:id" element={<ListingDetailPage />} />
        <Route path="/marketplace/listing/:id/edit" element={
          <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
            <EditListingPage />
          </ProtectedRoute>
        } />
        <Route path="/marketplace/sell" element={
          <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
            <CreateListingPage />
          </ProtectedRoute>
        } />
        <Route path="/marketplace/transaction/:id" element={
          <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
            <TransactionDetailPage />
          </ProtectedRoute>
        } />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/competition-schedule" element={<CompetitionSchedulePage />} />
        {/* <Route path="/community/price-reports" element={<ReportPriceListPage />} /> */}
        <Route path="/cards/:id" element={<CardDetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/beta-login"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <BetaLoginPage />
            </ProtectedRoute>
          }
        />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        {/* Messages routes disabled as per user request
        <Route
          path="/messages"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <MessagesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages/:userId"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <MessagesPage />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/notifications"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <NotificationsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/auctions" element={<AuctionListPage />} />
        <Route path="/auctions/create" element={<CreateAuctionPage />} />
        <Route path="/auctions/batch/:batchId" element={<AuctionBatchPage />} />
        <Route path="/auctions/:id" element={<AuctionDetailPage />} />
        <Route
          path="/auctions/new"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <CreateAuctionPage />
            </ProtectedRoute>
          }
        />
        <Route path="/users/:userId/reviews" element={<UserReviewsPage />} />

        {/* Admin Routes */}
        <Route
          path="/admin/listings"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminListingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <ManageUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/upload-images"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminCardUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/import-csv"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminCSVImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-cards"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminCardEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/price-moderation"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <PriceModerationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/price-management"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <PriceManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/announcements"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AnnouncementManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/carousel"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <CarouselManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/competition-schedule"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminCompetitionSchedulePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/listing-reports"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="moderator">
              <AdminListingReportsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/support"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <SupportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/support"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user} requiredRole="admin">
              <AdminSupportPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div >
  );
}

export default App;
